import { useEffect, type RefObject } from "react";

/** 헤더 배경이 다 깔리는 스크롤 거리(F03-24: 0→56px 동안 불투명도 0→1). */
export const HEADER_BG_FADE_PX = 56;

/** 스크롤 위치 → 헤더 배경 불투명도(0~1). */
export const headerBgOpacity = (scrollY: number): number => Math.min(1, Math.max(0, scrollY / HEADER_BG_FADE_PX));

/**
 * 채팅방 헤더 배경(F03-24 739:6636): 맨 위에선 투명, 내리면 0→56px 동안 서서히 깔린다.
 * 스크롤마다 리렌더하지 않도록 값은 CSS 변수(--chat-header-bg-opacity)로 컨테이너에 직접 쓴다. 헤더가 상속한다.
 */
export function useHeaderScrollBg(ref: RefObject<HTMLElement | null>): void {
  useEffect(() => {
    let frame = 0;
    const apply = () => {
      frame = 0;
      ref.current?.style.setProperty("--chat-header-bg-opacity", String(headerBgOpacity(window.scrollY)));
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(apply);
    };
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [ref]);
}
